// Single source of truth for which roles can create tickets.
// Keep this in sync with backend create_ticket access checks.
export const TICKET_CREATOR_ROLES = [
  "SystemAdmin",
  "President",
  "Finance",
  "Operations",
  "District Manager",
  "District Operations",
  "Store Manager",
  "HelpDesk",
  "Treasurer",
];

export const canCreateTickets = (role) =>
  !!role && TICKET_CREATOR_ROLES.includes(role);
